<div class="imageDev mt-2 pt-3">
    <div class="card">
        <div class="card-header">
            Abertura de chamados <span *ngIf="protocolo"><strong>{{protocolo}}</strong></span>
            <a class="btn btn-success btn-sm float-end" id="tooltip" (click)="ifParaListagem()"
                title="Listagem de chamados"><i class="fa fa-arrow-left"></i> Todos Chamados</a>
        </div>
        <div class="card-body">
            <form [formGroup]="form">
                <div class="col-12 d-flex" style="flex-direction: column;">
                    <div class="col-12 d-flex div-dados">
                        <div class="col-3">
                            <app-select-field formControlName="categoria" [itens]="_categorias" label="Categorias"></app-select-field>
                        </div>
                        <div class="col-4" style="margin-right: 15px;">
                            <app-input-field formControlName="assunto" label="Assunto" maxlength="300"></app-input-field>
                        </div>
                        <div class="col-3">
                            <app-input-field-info formControlName="protocoloOrcamento" label="Protocolo Orcamento" maxlength="300"
                                title="Insira aqui o protocolo do orçamento caso tenha"></app-input-field-info>
                        </div>
                    </div>
                    <div class="col-12 d-flex">
                        <div class="col-6 d-flex" style="flex-direction: column; margin-right: 15px;">
                            <div class="card">
                                <div class="card-header">
                                    Anexos<span style="float: right;">{{anexoStatus}}</span>
                                </div>
                                <div class="card-body">
                                    <div class="col-12 d-flex row">
                                        <div class="col-12 d-flex">
                                            <input type="file" id="input-arquivos" #arquivos class="form-control mr-1"
                                                (change)="salvarArquivos(arquivos)"
                                                multiple>
                                        </div>
                                        <div class="card-anexos">
                                            <div class="col-12 d-flex anexo" *ngFor="let anexo of listaAnexosExibicao">
                                                <span>{{anexo.nome}}</span>
                                                <div class="btns-action">
                                                    <button class="btn btn-open" title="Abrir Arquivo" (click)="abrirArquivo(anexo.uuid)">
                                                        <i class="fa fa-folder-open"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="desc-div d-flex" style="flex-direction: column;">
                            <div class="card">
                                <div class="card-header">
                                    <label for="desc" title="Descreva aqui em que podemos te ajudar" class="help">Descrição</label>
                                </div>
                                <div class="card-body" style="padding: 0px !important;">
                                    <textarea name="desc" id="desc" cols="30" rows="10" placeholder="Escreva aqui a descrição"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row" *ngIf="!travado">
                <div class="col colDev">
                    <button class="btn btn-success btnDev bg-teal btn-md mt-3" (click)="abrirChamado()">
                        <i class="fa fa-check" aria-hidden="true"></i> Abrir
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>